import { Suspense } from 'react';
import { Loading, UpdateApp } from '@optimization/ssi-common';
import { Outlet } from 'react-router';
import { APP_TITLE } from '@/app/config';
import CollapsedControllerProvider from '@/app/context/CollapsedControllerContext/collapsed-controller-provider';
import ElementControllerProvider from '@/app/context/ElementControllerContext/element-controller-provider';
import ImportCandidateModalProvider from '@/app/context/ImportCandidateModalContext/import-candidate-modal-provider';
import ScrollPositionRestoration from '@/common/components/ScrollPositionRestoration';
import BevManagerFilterProvider from '@/features/Bev/BevManager/context/bev-manager-filter-provider';
import GlobalLoading from '@/features/GlobalLoading/global-loading';
import {
  Datadog,
  Header,
  ImportCandidates,
  Layout,
  PageNotFound,
  RouteError,
  SolutionHomeOverview,
  ImportedDataChassisData,
  ImportedDataHistoricalOperation,
  SolutionManager,
  ReleaseNotes,
  ChargingManager,
  ChargingDetail,
  BevManager,
  BevDetail,
} from '@/route-components';

export const routes = {
  errorElement: (
    <Suspense fallback={<Loading isLoading />}>
      <RouteError />
    </Suspense>
  ),
  element: (
    <BevManagerFilterProvider>
      <ElementControllerProvider>
        <CollapsedControllerProvider>
          <GlobalLoading />
          <Suspense fallback={<Loading isLoading />}>
            <Datadog>
              <UpdateApp appTitle={APP_TITLE}>
                <Header />
                <ImportCandidateModalProvider>
                  <Outlet />
                </ImportCandidateModalProvider>
                <ScrollPositionRestoration />
              </UpdateApp>
            </Datadog>
          </Suspense>
        </CollapsedControllerProvider>
      </ElementControllerProvider>
    </BevManagerFilterProvider>
  ),
  children: [
    {
      element: (
        <Layout>
          <Outlet />
        </Layout>
      ),
      children: [
        {
          element: <SolutionManager />,
          errorElement: <RouteError />,
          path: '/',
        },
        {
          element: <ReleaseNotes />,
          errorElement: <RouteError />,
          path: '/release-notes',
        },
        {
          element: <ImportCandidates />,
          errorElement: <RouteError />,
          path: '/import-candidates',
        },
        {
          path: '/solution/:solutionId',
          element: <Outlet />,
          children: [
            {
              element: <SolutionHomeOverview />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/home',
            },
            {
              element: <ImportedDataChassisData />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/imported-data/chassis-data',
            },
            {
              element: <ImportedDataHistoricalOperation />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/imported-data/historical-operation',
            },
            {
              element: <BevManager />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/bevs',
            },
            {
              element: <BevDetail />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/bevs/:vehicleId',
            },
            {
              element: <BevDetail />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/bevs/:vehicleId/:tabPath',
            },
            {
              element: <ChargingManager />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/charging',
            },
            {
              element: <ChargingDetail />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/charging/:locationId/:tabPath',
            },
          ],
        },
        {
          path: 'callback',
        },
      ],
    },
    {
      path: '/*',
      element: <PageNotFound className="mt-spacing-88" />,
    },
  ],
};
